import { Spin } from 'antd';
import { Suspense, useEffect, useState } from 'react';
import './App.css';
import { MaintenanceRouter } from './Components/ErrorHandlers';
import FormExample from './Components/FormControl/FormExample';
import Loader from './Components/Loader/Loader';
import { appConfig } from './Environments/config';
import { socketConnection } from './Libraries/socket';
import RouteHandler from './Routing/RouteHandler';

const App = () => {


  useEffect(() => {
    socketConnection()
  }, [])

  /* If App is Under Maintenance then Routes would be disabled and Custom Maintenance Page would be rendered */
  return (
    appConfig.underMaintenance
      ?
      <MaintenanceRouter />
      : <Suspense fallback={<>Loading...</>}>
        <RouteHandler />
      </Suspense>
  )
}

export default App;
